import { cn } from '@/lib/utils';

import AudioMessage from './AudioMessage';
import CommentMessage from './CommentMessage';
import CustomMessage from './CustomMessage';
import EmailMessage from './EmailMessage';
import ImageMessage from './ImageMessage';
import PrivateReplyCommentMessage from './PrivateReplyCommentMessage';
import ReplyPreview from './ReplyPreview';
import StoryMessage from './StoryMessage';
import StoryReplyMessage from './StoryReplyMessage';
import TextMessage from './TextMessage';
import VideoMessage from './VideoMessage';

export default function MessageComponent({ message, isLastSentMessage }) {
  // Handle deleted messages centrally
  if (message.is_deleted === true || message.is_deleted === 'true') {
    return (
      <div className='rounded-md bg-muted px-3 py-2 text-sm opacity-60'>
        <p className='italic text-muted-foreground'>This message was deleted</p>
      </div>
    );
  }

  // Handle email channel messages
  if (message.channel === 'email') {
    return <EmailMessage {...message} isLastSentMessage={isLastSentMessage} />;
  }

  // Check if this message is a reply to another message
  const isReplyMessage = message.is_reply === true;

  // Render the appropriate message content based on type
  const renderMessageContent = () => {
    if (message.message_type === 'text') {
      if (message.private_reply_comment) {
        // Comment Private Reply
        return <PrivateReplyCommentMessage {...message} />;
      }
      // Text Message
      return <TextMessage {...message} isLastSentMessage={isLastSentMessage} />;
    }

    if (message.message_type === 'comment') {
      return <CommentMessage {...message} />;
    }

    if (!message.message_type || message.message_type === 'unsupported_type') {
      return (
        <CustomMessage {...message} customMessage={'Unsupported Message'} />
      );
    }

    if (message.media_url) {
      switch (message.message_type) {
        case 'audio':
          return (
            <AudioMessage {...message} isLastSentMessage={isLastSentMessage} />
          );
        case 'video':
          return (
            <VideoMessage {...message} isLastSentMessage={isLastSentMessage} />
          );
        case 'ig_reel':
          return (
            <VideoMessage {...message} isLastSentMessage={isLastSentMessage} />
          );
        case 'image':
          return (
            <ImageMessage {...message} isLastSentMessage={isLastSentMessage} />
          );
        case 'story_mention':
          return <StoryMessage {...message} />;
        case 'story_reply':
          return <StoryReplyMessage {...message} />;
        default:
          return null;
      }
    }

    return (
      <CustomMessage {...message} customMessage={'Message Not Available'} />
    );
  };

  // If this is a reply message, wrap content with reply preview
  if (isReplyMessage) {
    return (
      <div
        className={cn(
          'rounded-lg p-1',
          message.direction === 'sent'
            ? 'bg-muted'
            : 'bg-received text-primary-foreground'
        )}
      >
        <ReplyPreview
          replyToText={message.reply_to_text}
          replyToMessageType={message.reply_to_message_type}
          replyToMediaUrl={message.reply_to_media_url}
          direction={message.direction}
        />
        <div className='px-2 pb-1'>{renderMessageContent()}</div>
      </div>
    );
  }

  return renderMessageContent();
}
